import { Spacing } from '@persona-id/design-tokens';
import { Link } from 'react-router-dom-v5-compat';
import styled from 'styled-components';

import Divider from 'dashboard/components/Divider';
import Spacer from 'design-system/components/Spacer';
import { Display, Paragraph } from 'design-system/components/Text';
import { BASE } from 'design-system/variables/spacing';
import LogoLight from 'images/brand/logo-color-light.svg';

const DashboardSignupActivateView = () => (
  <PageContainer>
    <Logo />
    <Divider full />
    <ContentContainer>
      <Display size='sm'>Oops!</Display>
      <Spacer height={5} />
      <Paragraph size='lg'>
        Sorry, this link has expired. Please sign up again{' '}
        <Link to='/dashboard/register'>here</Link>.
      </Paragraph>
    </ContentContainer>
  </PageContainer>
);

const PageContainer = styled('div')`
  position: relative;
  background-color: ${({ theme }) => theme.color.primary.white};
  width: 100%;
  height: 100%;
  min-height: 100vh;
`;

const Logo = styled(LogoLight)`
  width: 128px;
  height: auto;
  margin-top: ${Spacing[4]};
  margin-left: ${Spacing[5]};
  margin-bottom: -${Spacing[2]};
`;

const ContentContainer = styled('div')`
  max-width: 1024px;
  margin: auto;
  padding-top: ${Spacing[7]};
  padding-bottom: ${BASE * 10}px;
  padding-left: ${Spacing[5]};
  padding-right: ${Spacing[5]};
`;

export default DashboardSignupActivateView;
